import React from "react";
import { observer } from "mobx-react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import $apiKeys from "@/core/apiKeys/store";

const formatDate = (value) =>
  value ? new Date(value).toLocaleString("ru-RU") : "—";

// Заголовок зависит от роли не ради красоты: администратору сюда приходят ключи
// всех сотрудников, и «Ваши ключи» над чужими строками врали бы.
const KeysTable = ({ isAdmin, onCreate }) => {
  const keys = $apiKeys.getData;

  return (
    <Card variant="outlined">
      <Typography variant="subtitle1" sx={{ px: 2, py: 1.5 }}>
        {isAdmin ? "Все ключи" : "Ваши ключи"}
      </Typography>
      <Divider />
      {keys.length === 0 ? (
        <Box sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Ключей пока нет. Выпуск занимает несколько секунд, подключение —
            одну команду.
          </Typography>
          <Button variant="outlined" onClick={onCreate}>
            Выпустить ключ
          </Button>
        </Box>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Название</TableCell>
              {isAdmin && <TableCell>Владелец</TableCell>}
              <TableCell>Создан</TableCell>
              <TableCell>Использован</TableCell>
              <TableCell>Статус</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {keys.map((key) => (
              <TableRow key={key.id}>
                <TableCell>{key.name}</TableCell>
                {isAdmin && <TableCell>{key.owner}</TableCell>}
                <TableCell>{formatDate(key.createdAt)}</TableCell>
                <TableCell>{formatDate(key.lastUsedAt)}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    variant="outlined"
                    color={key.revokedAt ? "default" : "success"}
                    label={key.revokedAt ? "отозван" : "активен"}
                  />
                </TableCell>
                <TableCell align="right">
                  {!key.revokedAt && (
                    <Button
                      size="small"
                      color="error"
                      onClick={() => $apiKeys.revoke(key.id)}
                    >
                      Отозвать
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  );
};

export default observer(KeysTable);
